export default "__VITE_ASSET__D9OPES4E__"